import DeliveryCard from './DeliveryCard';

export default DeliveryCard;
